import { t } from "@lingui/core/macro";
import graphql from "babel-plugin-relay/macro";
import { format, isEqual } from "date-fns";
import { useFragment } from "react-relay";

import { InfoBanner } from "@whoosh/design-system/src/components/display/InfoBanner";
import { convertDateStringToObj } from "@whoosh/utilities/src/dates";

import { CanceledPackageBanner_memberPackage$key } from "./__generated__/CanceledPackageBanner_memberPackage.graphql";

type Props = {
  memberPackageRef: CanceledPackageBanner_memberPackage$key | null | undefined;
};

export const CanceledPackageBanner = ({ memberPackageRef }: Props) => {
  const memberPackage = useFragment(
    CanceledPackageBannerFragmentString,
    memberPackageRef
  );

  // Extract and parse dates
  const endDate = memberPackage?.endsOn
    ? convertDateStringToObj(memberPackage.endsOn)
    : undefined;
  const cancelDate = memberPackage?.cancelledOn
    ? convertDateStringToObj(memberPackage.cancelledOn.split(" ")[0])
    : undefined;

  // Helper to format a date or return undefined
  const formatDate = (date: Date) => format(date, "MMM do, yyyy");

  let message: string;
  if (cancelDate) {
    const cancelDateStr = formatDate(cancelDate);
    if (endDate && isEqual(cancelDate, endDate)) {
      message = t`This subscription was canceled on ${cancelDateStr}, you will have access to your benefits until ${formatDate(
        endDate
      )}.`;
    } else {
      message = t`This subscription was canceled on ${cancelDateStr}.`;
    }
  } else {
    message = t`This subscription has been canceled.`;
  }

  return <InfoBanner message={message} colorTheme="ERROR" />;
};

const CanceledPackageBannerFragmentString = graphql`
  fragment CanceledPackageBanner_memberPackage on MemberPackage {
    id
    cancelledOn
    endsOn
  }
`;
